// TODO Refactor TrackingConfig => ?
// Irgendwas, das besser passt
class TrackingConfig {
	constructor () {
		window.scrollPosition = 0;
		window.scrollPositionOld25 = false;
		window.scrollPosition25 = false;
		window.scrollPosition50 = false;
		window.scrollPosition75 = false;
		window.scrollPosition100 = false;

		this.init();
	}

	init () {
		document.addEventListener('DOMContentLoaded', () => {
			// Click Event für die Suche
			if (document.querySelector('#searchbar')) {
				document.querySelector('#searchbar').addEventListener('click', (event) => {
					window.Tracking.trackMe(
						{
							section: 'homepage.header.search.focus',
							trackingtype: 'cl',
							posi_block: 1
						},
						event
					);
				});
			}

			// für das Öffnen der Bento Menüs
			if (document.querySelector('[data-component="bento"] label')) {
				[...document.querySelectorAll('[data-component="bento"] label')].forEach((element) => {
					element.addEventListener('click', (event) => {
						window.Tracking.trackMe(
							{
								section: 'homepage.productselection.open',
								trackingtype: 'cl',
								posi_block: 1
							},
							event
						);
					});
				});
			}

			// für die Auswahl im Bento Menü
			if (document.querySelector('[data-component="bento"] [data-component="simple"]')) {
				[...document.querySelectorAll('[data-component="bento"] [data-component="simple"]')].forEach((element) => {
					element.addEventListener('click', (event) => {
						window.Tracking.trackMe(
							{
								section: 'homepage.productselection.select',
								trackingtype: 'cl',
								posi_block: 1
							},
							event
						);
					});
				});
			}

			// News Slider weiter
			if (document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="arrow-next"]')) {
				document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="arrow-next"]').addEventListener('click', (event) => {
					let currentSlide = document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="indicators"] [data-current]').getAttribute('data-indicator');

					window.Tracking.trackMe(
						{
							section: 'homepage.hero.right',
							trackingtype: 'cl',
							posi_comp: +currentSlide + 1,
							posi_block: 2
						},
						event
					);
				});
			}

			// News Slider zurück
			if (document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="arrow-prev"]')) {
				document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="arrow-prev"]').addEventListener('click', (event) => {
					let currentSlide = document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="indicators"] [data-current]').getAttribute('data-indicator');

					window.Tracking.trackMe(
						{
							section: 'homepage.hero.left',
							trackingtype: 'cl',
							posi_comp: +currentSlide + 1,
							posi_block: 2
						},
						event
					);
				});
			}

			// News Slider Tabs
			if (document.querySelector('[data-name="viewport"] [data-component="slider"] [data-part="indicators"] [data-indicator]')) {
				[...document.querySelectorAll('[data-name="viewport"] [data-component="slider"] [data-part="indicators"] [data-indicator]')].forEach((element) => {
					element.addEventListener('click', (event) => {
						window.Tracking.trackMe(
							{
								section: 'homepage.hero.tab',
								trackingtype: 'cl',
								posi_comp: +event.target.getAttribute('data-indicator') + 1,
								posi_block: 2
							},
							event
						);
					});
				});
			}

			/* Login im Header ... gibts nicht mehr */
			// // Login im Header öffnen Button
			// if (document.querySelector('header [data-login-button]')) {
			// 	document.querySelector('header [data-login-button]').addEventListener('click', (event) => {
			// 		window.Tracking.trackMe(
			// 			{
			// 				section: 'homepage.loginformular.open',
			// 				trackingtype: 'cl',
			// 				posi_block: 1
			// 			},
			// 			event
			// 		);

			// 		window.Tracking.trackMe(
			// 			{
			// 				section: 'homepage.loginformular.view',
			// 				trackingtype: 'ev',
			// 				posi_block: 1
			// 			},
			// 			event
			// 		);
			// 	});
			// }

			// // Passwort sichbar oder nicht Button
			// if (document.querySelector('header #passwordfield + [data-component="button"]')) {
			// 	document.querySelector('header #passwordfield + [data-component="button"]').addEventListener('click', (event) => {
			// 		let passwordVisible = 'visible';
			// 		let inputField = document.querySelector('header #passwordfield');
			// 		if (inputField.getAttribute('type') === 'password') {
			// 			passwordVisible = 'invisible';
			// 		}

			// 		window.Tracking.trackMe(
			// 			{
			// 				section: 'homepage.loginformular.password.' + passwordVisible,
			// 				trackingtype: 'cl',
			// 				posi_block: 1
			// 			},
			// 			event
			// 		);
			// 	});
			// }

			// // Login Button
			// if (document.querySelector('header [data-component="login"] > [data-component="button"]')) {
			// 	document.querySelector('header [data-component="login"] > [data-component="button"]').addEventListener('click', (event) => {
			// 		window.Tracking.trackMe(
			// 			{
			// 				section: 'homepage.loginformular.login',
			// 				trackingtype: 'cl',
			// 				posi_block: 1
			// 			},
			// 			event
			// 		);
			// 	});
			// }

			// // Änderung der Loginart (also z.B. auf Online-Speicher)
			// if (document.querySelector('header [data-component="login"] > span')) {
			// 	document.querySelector('header [data-component="login"] > span').addEventListener('DOMSubtreeModified', (event) => {
			// 		// unklar welche Elemente tatsächlich den Login verändern. Es soll aber nur auf diese reagiert werden.
			// 		// TODO: Hier sollte man sich besser an die (noch nicht existente) Funktion hängen, welche den Logintext tatsächlich verändert. Eventuell über eine custom Event.
			// 		window.Tracking.trackMe(
			// 			{
			// 				section: 'homepage.loginformular.update.view',
			// 				trackingtype: 'ev',
			// 				posi_block: 1
			// 			},
			// 			event
			// 		);
			// 	});
			// }
			// /* */

			/* Login im Content */
			// Passwort sichbar oder nicht Button
			if (document.querySelector('.main-content > header [data-component="login"] #passwordfield + [data-component="button"]')) {
				document.querySelector('.main-content > header [data-component="login"] #passwordfield + [data-component="button"]').addEventListener('click', (event) => {
					let passwordVisible = 'homepage.loginformular.password.visible';
					let inputField = document.querySelector('header #passwordfield');
					if (inputField.getAttribute('type') === 'password') {
						passwordVisible = 'homepage.loginformular.password.invisible';
					}

					window.Tracking.trackMe(
						{
							section: 'homepage.loginformular.password.' + passwordVisible,
							trackingtype: 'cl',
							posi_block: 2
						},
						event
					);
				});
			}

			// Login Button
			if (document.querySelector('.main-content > [data-component="login"] > [data-component="button"]')) {
				document.querySelector('.main-content > [data-component="login"] > [data-component="button"]').addEventListener('click', (event) => {
					window.Tracking.trackMe(
						{
							section: 'homepage.loginformular.login',
							trackingtype: 'cl',
							posi_block: 2
						},
						event
					);
				});
			}

			// Änderung der Loginart (also z.B. auf Online-Speicher)
			if (document.querySelector('.main-content > [data-component="login"] > span')) {
				document.querySelector('.main-content > [data-component="login"] > span').addEventListener('DOMSubtreeModified', (event) => {
					// unklar welche Elemente tatsächlich den Login verändern. Es soll aber nur auf diese reagiert werden.
					// TODO: Hier sollte man sich besser an die (noch nicht existente) Funktion hängen, welche den Logintext tatsächlich verändert. Eventuell über eine custom Event.
					window.Tracking.trackMe(
						{
							section: 'homepage.loginformular.update.view',
							trackingtype: 'ev',
							posi_block: 2
						},
						event
					);
				});
			}
			/* */

			window.addEventListener('scroll', (event) => {
				let scrollPosition = this.getScrollPercent();
				if (window.scrollPosition < scrollPosition) {
					window.scrollPosition = scrollPosition;
				}

				// 8397px is the height of the old hp (with billboard and after scrolling all the way down)
				if (window.scrollY >= 8397 / 4 && !window.scrollPositionOld25) {
					window.Tracking.trackMe({
						section: 'homepage.scroll.oldhp25',
						trackingtype: 'ev'
					});
					window.scrollPositionOld25 = true;
				}

				if (window.scrollPosition >= 25 && !window.scrollPosition25) {
					window.Tracking.trackMe({
						section: 'homepage.scroll.25',
						trackingtype: 'ev'
					});
					window.scrollPosition25 = true;
				}
				if (window.scrollPosition >= 50 && !window.scrollPosition50) {
					window.Tracking.trackMe({
						section: 'homepage.scroll.50',
						trackingtype: 'ev'
					});
					window.scrollPosition50 = true;
				}
				if (window.scrollPosition >= 75 && !window.scrollPosition75) {
					window.Tracking.trackMe({
						section: 'homepage.scroll.75',
						trackingtype: 'ev'
					});
					window.scrollPosition75 = true;
				}
				if (window.scrollPosition >= 95 && !window.scrollPosition100) {
					window.Tracking.trackMe({
						section: 'homepage.scroll.100',
						trackingtype: 'ev'
					});
					window.scrollPosition100 = true;
				}
			});
		});
	}

	getScrollPercent () {
		let h = document.documentElement;
		let b = document.body;
		let st = 'scrollTop';
		let sh = 'scrollHeight';
		return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
	}
}

export { TrackingConfig };
